import { useMutation } from '@tanstack/react-query';
import { ampli } from '../../../../ampli';
import { patchUserFlarelaneTags } from '../../../../api/user/mutations/patchUserFlarelaneTags';

export const usePatchUserFlarelaneTagsMutation = () => {
  return useMutation(patchUserFlarelaneTags, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '플레어레인 태그 동기화 실패',
        '에러가 발생한 URL': '/after-login',
      }),
  });
};
